export const MODULES = {
  ACCOUNT: 1,
  DC: 2,
  DI: 3,
  SEGMENT: 4,
  ADMIN_TOOL: 5,
  COMMU: 6,
  MKA: 7,
  CUSTOMER_PROFILE: 8,
  BI: 9,
} as const;

export const EVENTS = {
  MENU: 1,
  CREATE: 2,
  UPDATE: 3,
  DELETE: 4,
  VIEW: 5,
  SETTING: 6,
  INVITE: 7,
  UPLOAD: 8,
  DOWNLOAD: 9,
  COPY: 10,
  LOGIN: 11,
  LOGOUT: 12,
  CHANGE_PASSWORD: 13,
  START: 14,
  PAUSE: 15,
  STOP: 16,
  CONFIRM: 17,
} as const;
